import { Suspense, useState } from 'react';
import { css } from '@emotion/react';
import { MyPageCharacterErrorBoundary } from '~/components/ErrorBoundary';
import { MyPageCharacterListSkeleton } from '~/components/common/Skeleton';
import LikedCharacter from './LikedCharacter/LikedCharacter';
import MyCharacter from './MyCharacter/MyCharacter';
import TabMenu from './TabMenu/TabMenu';

export type MyPageCharacterTab = 'MyCharacter' | 'LikedCharacter';

export default function Character() {
  const [selectedTab, setSelectedTab] =
    useState<MyPageCharacterTab>('MyCharacter');

  const handleTabChange = (tab: MyPageCharacterTab) => {
    setSelectedTab(tab);
  };

  return (
    <div
      css={css`
        display: flex;
        flex: 1;
        flex-direction: column;
        gap: 24px;
      `}
    >
      <TabMenu selectedTab={selectedTab} handleTabChange={handleTabChange} />

      <Suspense fallback={<MyPageCharacterListSkeleton />}>
        {selectedTab === 'MyCharacter' && (
          <MyPageCharacterErrorBoundary>
            <MyCharacter />
          </MyPageCharacterErrorBoundary>
        )}
        {selectedTab === 'LikedCharacter' && (
          <MyPageCharacterErrorBoundary>
            <LikedCharacter />
          </MyPageCharacterErrorBoundary>
        )}
      </Suspense>
    </div>
  );
}
